import { Embed, Report, models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import "powerbi-report-authoring";
import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import { Container, Row } from "reactstrap";
import { URL } from "../constants/index";
import api from "../services/api";
import { login, logout, obterNovaAutenticacao } from "../services/auth";
import "./Layout/Dashboard.css";
import NavBI from "./NavBI";

// Root Component to demonstrate usage of wrapper component
function DashboardTS(props: any): JSX.Element {
  // PowerBI Report object (to be received via callback)
  const [report, setReport] = useState<Report>();

  // API end-point url to get embed config for a sample report
  const urlAPIDashboard = "/api/dashboard/DashboardAtual";
  // Report config useState hook
  // Values for properties like embedUrl, accessToken and settings will be set on click of buttons below

  const [menu, setMenu] = useState([]);
  const [loadingErro, setLoadingErro] = useState(false);
  const [loading, setLoading] = useState(true);

  const [width, setWidth] = useState<number>(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const [sampleReportConfig, setReportConfig] = useState<
    | models.IReportEmbedConfiguration
    | models.IDashboardEmbedConfiguration
    | models.ITileEmbedConfiguration
    | models.IVisualEmbedConfiguration
    | models.IEmbedConfiguration
  >({
    type: "report",
    embedUrl: undefined,
    tokenType: models.TokenType.Aad,
    accessToken: undefined,
    pageName: isMobile ? props.pageName : props.pageNameMobile,
    settings: {
      layoutType: isMobile
        ? models.LayoutType.MobilePortrait
        : models.LayoutType.Custom,

      panes: {
        filters: {
          expanded: false,
          visible: false,
        },
        pageNavigation: {
          visible: false,
        },
      },
    },
    filters: undefined,
  });

  // Carregar o dashboard no incio
  useEffect(() => {
    carregarDashboard();
  }, []);

  // Timer para recarregar o dashboard
  useEffect(() => {
    const intervaloDashboard = setInterval(() => {
      carregarDashboard();
    }, 1800000);

    const intervalAutenticacao = setInterval(() => {
      const response = obterNovaAutenticacao();

      response.then((res) => {
        login(res.data);
      });
      response.catch((err) => {
        logout()
          .then((res) => props.history.push(URL.URLLogin))
          .catch((res) => props.history.push(URL.URLLogin));
      });
    }, 900000);

    return () => {
      clearInterval(intervalAutenticacao);
      clearInterval(intervaloDashboard);
    };
  }, []);

  const carregarDashboard = async () => {
    api
      .get(urlAPIDashboard)
      .then((res) => {
        const target: models.IFilterColumnTarget = {
          table: "",
          column: "",
        };

        const filterList: models.IFilter[] = [];

        const filterReport: models.IBasicFilter = {
          operator: "In",
          values: [],
          $schema: "",
          target: target,
          filterType: models.FilterType.Basic,
        };

        if (
          res.data.filtroDashboard != undefined &&
          res.data.filtroDashboard.length > 0
        ) {
          
          var x = 0;
          var y = 0;

          if(res.data.filtroDashboard[x].filterType != 1 ){
            
            const conditions: any = []

            for (x = 0; x < res.data.filtroDashboard.length; x++) {
              const filterReport: models.IAdvancedFilter = {
                $schema: "",
                target: target,
                conditions: [],
                logicalOperator: "Or",
                filterType: models.FilterType.Advanced,
              };

              for(y=0; y < res.data.filtroDashboard[x].values.length; y++){
                conditions.push ({
                  operator: res.data.filtroDashboard[x].operator
                  ,value: res.data.filtroDashboard[x].values[y]
                })
              }

              filterReport.conditions = conditions;
              filterReport.$schema = res.data.filtroDashboard[x].$schema;
              filterReport.target = res.data.filtroDashboard[x].target;
  
              filterList.push(filterReport);

            }

          }else{

            for (x = 0; x < res.data.filtroDashboard.length; x++) {
              const filterReport: models.IBasicFilter = {
                operator: "In",
                values: [],
                $schema: "",
                target: target,
                filterType: models.FilterType.Basic,
              };
              filterReport.operator = res.data.filtroDashboard[x].operator;
              filterReport.values = res.data.filtroDashboard[x].values;
              filterReport.$schema = res.data.filtroDashboard[x].$schema;
              filterReport.target = res.data.filtroDashboard[x].target;
  
              filterList.push(filterReport);
            }
  
          }

          setMenu(res.data.listaMenu);
          setReportConfig({
            ...sampleReportConfig,
            embedUrl: res.data.embedURL,
            accessToken: res.data.accessToken,
            filters: filterList,
          });
          setLoading(false);
        } else {
          setMenu(res.data.listaMenu);
          setReportConfig({
            ...sampleReportConfig,
            embedUrl: res.data.embedURL,
            accessToken: res.data.accessToken,
            filters: undefined,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        setLoadingErro(true);
        console.log(err);
      });
  };

  if (loading) {
    return (
      <div id="content-bi">
        <NavBI menu={menu} history={props.history} />

        <Container>
          <Row className="justify-content-center">
            <ReactLoading
              type="bubbles"
              color="#343a40"
              height={100}
              width={100}
            />
          </Row>
        </Container>
      </div>
    );
  }

  if (loadingErro) {
    return (
      <div id="content-bi">
        <NavBI menu={menu} history={props.history} />

        <Container>
          <Row className="justify-content-center">
            <h3>Ocorreu um problema ao carregar dashboard</h3>
          </Row>
        </Container>
      </div>
    );
  }
  return (
    <div id="content-bi">
      <NavBI menu={menu} history={props.history} report={report} />

      <PowerBIEmbed
        embedConfig={sampleReportConfig}
        cssClassName={"report-style-class"}
        getEmbeddedComponent={(embedObject: Embed) => {
          setReport(embedObject as Report);
        }}
      />
    </div>
  );
}

export default DashboardTS;